import { storeLocale } from '../../actions/localization/actions';

export const localisationDispatch = (dispatch) => ({
  dispatchStoreLocale: (payload: any) => {
    dispatch(storeLocale(payload));
  },
});

export default localisationDispatch;
